define('controllers/mysetting/mod-payservice.ctrl',['app'], function (app) {
    app.controller('ModPayServiceCtrl', ['$q', '$scope', '$state', 'auiUpload', 'auiDialog', 'OpenApp', 'UserInfo', 'regionService', 'invoiceService', 'UserInfoPreload', 'auiAgreementHelper', 'payService', '$rootScope',
        function ($q, $scope, $state, auiUpload, auiDialog, OpenApp, UserInfo, regionService, invoiceService, UserInfoPreload, auiAgreementHelper, payService, $rootScope) {
            var Model = $scope.Model = {};
            Model.serviceStateMsg = '';
            Model.isIconShow = false;
            Model.pageShowErrMsg = false;
            Model.firstmessTip = '';
            Model.secondmessTip = '';
            Model.payAgreementType = {0: 'PAYSVICEPROXY', 1: 'PAYSVICE'};
            init(true);


            function init(flag) {
                payService.isPayable().then(function (isPay) {
                    if (isPay) {
                        Model.serviceStateMsg = '付费服务已开通';
                        Model.isIconShow = false;
                    } else {
                        Model.serviceStateMsg = '付费服务未开通';
                        Model.isIconShow = true;
                    }
                });
                var status = payService.getPayStatusByUser(UserInfoPreload);
                if (status == 3) {
                    invoiceService.getNotifyMessage(function (res) {
                        if (res) {
                            Model.pageShowErrMsg = true;
                            Model.errorPayServiceMsg = "您填写的付费服务信息有误： " + res;
                        }
                    });
                }
            }

            // 父级接收
            $scope.$on('changePage', function (event, data) {
                init();
            });

        }]);
});
